import React from "react";
import { useAuth } from "../hooks/useAuth";
import { Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";

function HeaderDashboard() {
  const { user, logout } = useAuth();

  return (
    <Navbar expand="lg" className="bg-body-tertiary header">

      <Navbar.Brand href="/dashboard">
        <img src="/images/logo.png" alt="Logo" height="32"/>
      </Navbar.Brand>

      <div className="links justify-self-right">
        <Link to="/dashboard" className="link">Petiţii</Link>

        {user().roles.includes("Admin") && (
          <Link to="/dashboard/users" className="link">Conturi</Link>
        )}

        <Link to="/dashboard/problem/create" className="link">Creare</Link>
      
        <Link to="/dashboard/forms" className="link">Formulare</Link>

        <Link to="#" onClick={() => logout()} >
          <img src="/images/logout.png" alt="Logout" height="32" />
        </Link>
      </div>
    </Navbar>
  );
}

export default HeaderDashboard;